import React from 'react'

import { Modal } from '@gousto-internal/citrus-react'

import type { RecipeCoreId, RecipeUUID } from '@library/menu-service'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { DetailContent } from './DetailContent'

import css from './Detail.css'

type DetailProps = {
  uuid: RecipeUUID
  coreId: RecipeCoreId
  title: string
  showOverlay: boolean
  error: boolean
  loading: boolean
  recipe: MenuRecipe | null
  position?: string
  reload: () => void
  onClose: () => void
  isScrollableBasketEnabled: boolean
}

export const Detail = ({
  uuid,
  coreId,
  title,
  showOverlay,
  error,
  loading,
  recipe,
  reload,
  onClose,
  position,
  isScrollableBasketEnabled,
}: DetailProps) => (
  <Modal
    name="recipe-detail-modal"
    isOpen={showOverlay}
    onRequestClose={onClose}
    overlayClassName={css.overlay}
  >
    <DetailContent
      uuid={uuid}
      coreId={coreId}
      title={title}
      error={error}
      loading={loading}
      recipe={recipe}
      reload={reload}
      onClose={onClose}
      position={position}
      isScrollableBasketEnabled={isScrollableBasketEnabled}
    />
  </Modal>
)
